'use client';
import '~theme/global.css';

import { useEffect } from 'react';

import { Captions, SubHeadline, Text, Title } from '~components/Typography';
import ClientLogger from '~logger/client';
import { LoggerMessages, LoggerServices } from '~logger/constants';
// TODO: Design/markup, insta redirect?
export default function GlobalError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset?: () => void;
}) {
	useEffect(
		() =>
			ClientLogger.error(LoggerServices.Global, LoggerMessages.Unknown, {
				error,
			}),
		//eslint-disable-next-line
		[]
	);

	return (
		<html>
			<body style={{ justifyContent: 'center', alignItems: 'center', gap: 20 }}>
				<Title size="S">Something went wrong!</Title>
				<Text>
					{error?.name}: {error?.message}
				</Text>
				<Captions>{error?.stack}</Captions>
				<button onClick={() => reset?.()}>
					<SubHeadline size="L">Try again</SubHeadline>
				</button>
			</body>
		</html>
	);
}
